import PageHero from "@/components/shared/PageHero";
import CalculatorsSection from "@/components/sections/CalculatorsSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function CalculatorsPage() {
  return (
    <div data-testid="page-calculators">
      <PageHero
        eyebrow="Calculators"
        title={<>Run the <span className="italic text-bronze">numbers</span> — quickly.</>}
        sub="Three Singapore-focused estimators — mortgage repayment, sales proceeds, and total cost of purchase. Results are indicative only."
        image={ASSETS.lifestyle.handshake}
        ctas={[
          { label: "Get Personal Advice", href: BRAND.whatsapp, variant: "primary" },
          { label: "Get Valuation", href: BRAND.valuationLink, variant: "secondary" },
        ]}
        meta={[
          { label: "Tools", value: "3 calculators" },
          { label: "TDSR rule", value: "55% of income" },
          { label: "Updated", value: "SG 2025" },
        ]}
      />
      <CalculatorsSection withHeading={false} />
      <CTASection />
    </div>
  );
}
